import { getPlatformBrand } from '@/api'

const DEFAULT_NAME = '小冷电竞'

const state = {
  appName: localStorage.getItem('platform_app_name') || DEFAULT_NAME,
  logo: localStorage.getItem('platform_logo') || ''
}

const mutations = {
  SET_BRAND(state, { appName, logo }) {
    if (appName) {
      state.appName = appName
      localStorage.setItem('platform_app_name', appName)
    }
    if (logo !== undefined) {
      state.logo = logo || ''
      if (logo) localStorage.setItem('platform_logo', logo)
      else localStorage.removeItem('platform_logo')
    }
    document.title = `${state.appName} - 管理后台`
  }
}

const actions = {
  fetchBrand({ commit }) {
    return getPlatformBrand().then(res => {
      const data = res.data || {}
      commit('SET_BRAND', {
        appName: data.app_name || DEFAULT_NAME,
        logo: data.logo || ''
      })
      return data
    }).catch(() => {})
  },
  setBrand({ commit }, payload) {
    commit('SET_BRAND', {
      appName: payload.app_name || payload.appName || DEFAULT_NAME,
      logo: payload.logo !== undefined ? payload.logo : undefined
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
